import { PublicSponsorshipVoucherApi } from '@blank/api'
import { AxiosError } from 'axios'
import { ApiError } from 'modules/common/types/error'
import { fetchPublicSponsorshipVoucher } from '../api/fetchPublicSponsorshipVoucher'
import { useLazyQuery } from '../hooks/useLazyQuery'
import { LazyQueryOptions } from '../types/queries'
import { EnumAuthQueryKeys } from './keys'

export type PublicSponsorshipVoucherLazyQueryOptions = LazyQueryOptions<
  PublicSponsorshipVoucherApi,
  AxiosError<ApiError>
>
interface Props {
  voucherCode: string | undefined
  queryOptions?: PublicSponsorshipVoucherLazyQueryOptions
}
export const usePublicSponsorshipVoucherLazyQuery = ({
  voucherCode,
  queryOptions,
}: Props) => {
  return useLazyQuery<PublicSponsorshipVoucherApi, AxiosError<ApiError>>({
    queryKey: [EnumAuthQueryKeys.PUBLIC_SPONSORSHIP_VOUCHER],
    queryFn: async (_context) => {
      if (!voucherCode) {
        throw new Error(
          'usePublicSponsorshipVoucherLazyQuery: voucherCode is missing'
        )
      }

      return fetchPublicSponsorshipVoucher({
        voucherCode,
      })
    },
    ...queryOptions,
  })
}
